import React from 'react';
import { useTranslation } from 'react-i18next';
import { UserPlus, ClipboardList, FileText, TrendingUp } from '../../components/Icons';
import styles from './HowItWorks.module.css';

function HowItWorks() {
  const { i18n } = useTranslation();
  const isID = i18n.language === 'id';

  const steps = [
    {
      icon: <UserPlus size={32} strokeWidth={1.5} aria-hidden="true" />,
      title: isID ? 'Buat akun gratis' : 'Create free account',
      desc: isID ? 'Daftar dalam 1 menit' : 'Sign up in 1 minute',
    },
    {
      icon: <ClipboardList size={32} strokeWidth={1.5} aria-hidden="true" />,
      title: isID ? 'Tambah profil anak' : 'Add child profile',
      desc: isID ? 'Input data & faktor risiko' : 'Input data & risk factors',
    },
    {
      icon: <FileText size={32} strokeWidth={1.5} aria-hidden="true" />,
      title: isID ? 'Catat & lakukan skrining' : 'Log & run screening',
      desc: isID
        ? 'Tambah catatan perkembangan dan lakukan skrining ilmiah'
        : 'Add progress logs and run scientific screening',
    },
    {
      icon: <TrendingUp size={32} strokeWidth={1.5} aria-hidden="true" />,
      title: isID ? 'Pantau perkembangan' : 'Monitor progress',
      desc: isID ? 'Grafik & laporan lengkap' : 'Charts & complete reports',
    },
  ];

  return (
    <section className={styles.how}>
      <div className={styles.container}>
        <div className="eyebrow">{isID ? 'Cara Kerja' : 'How It Works'}</div>
        <h2 className={`section-headline ${styles.headline}`}>
          {isID ? 'Mulai dalam hitungan menit' : 'Get started in minutes'}
        </h2>

        <ol className={styles.grid}>
          {steps.map((s, i) => (
            <li key={i} className={styles.step}>
              <div className={styles.iconCircle}>{s.icon}</div>
              <div className={styles.stepBody}>
                <div className={styles.stepTitle}>{s.title}</div>
                <div className={styles.stepDesc}>{s.desc}</div>
              </div>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}

export default HowItWorks;